import { useEffect, useState } from "react";
import { BookOpen, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const ESC_BRIDGE = `<script>document.addEventListener("keydown",function(e){if(e.key==="Escape"&&!document.querySelector(".lightbox:not([hidden])"))parent.postMessage("hs-guide-close","*")});</script>`;

function GuideModal({ onClose }) {
  const [html, setHtml] = useState(null);
  useEffect(() => {
    api.get("/guide", { responseType: "text" }).then((r) => setHtml(r.data + ESC_BRIDGE)).catch((e) => { toast.error(errMsg(e)); onClose(); });
    const esc = (e) => e.key === "Escape" && onClose();
    const msg = (e) => e.data === "hs-guide-close" && onClose();
    window.addEventListener("keydown", esc);
    window.addEventListener("message", msg);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", esc); window.removeEventListener("message", msg); document.body.style.overflow = ""; };
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-[100] bg-white flex flex-col" data-testid="guide-modal" role="dialog" aria-label="Guida Halfa Stamps">
      <div className="h-12 shrink-0 flex items-center justify-between px-4 bg-brand-navy text-white">
        <span className="font-semibold flex items-center gap-2"><BookOpen className="w-4 h-4 text-brand-yellow" /> Guida all'uso del sito</span>
        <button data-testid="guide-close-btn" onClick={onClose} className="press h-9 px-3 rounded-md bg-white/10 hover:bg-white/20 flex items-center gap-1 text-sm"><X className="w-4 h-4" /> Chiudi</button>
      </div>
      {html === null
        ? <div className="flex-1 grid place-items-center"><Loader2 className="w-8 h-8 animate-spin text-brand-navy" /></div>
        : <iframe title="Guida Halfa Stamps" data-testid="guide-frame" srcDoc={html} sandbox="allow-scripts allow-popups" className="flex-1 w-full border-0" />}
    </div>
  );
}

export function GuideButton({ className = "", testid = "guide-open-btn" }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user?.has_guide) return null;
  return (
    <>
      <button data-testid={testid} onClick={() => setOpen(true)}
        className={`press inline-flex items-center gap-2 h-11 px-5 rounded-md bg-brand-yellow text-brand-navy font-bold shadow-sm hover:brightness-95 ${className}`}>
        <BookOpen className="w-5 h-5" /> Guida all'uso del sito
      </button>
      {open && <GuideModal onClose={() => setOpen(false)} />}
    </>
  );
}

export function GuideStrip() {
  const { user } = useAuth();
  if (!user?.has_guide) return null;
  return (
    <div className="bg-brand-navy" data-testid="guide-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-white"><b className="text-brand-yellow">Nuovo al sito?</b> Apri la guida interattiva: ordini, editor e riordini passo per passo.</p>
        <GuideButton testid="home-guide-btn" className="h-10" />
      </div>
    </div>
  );
}
